// eslint-disable-next-line import/prefer-default-export
export const COOKIE_NAME = 'ab-optimize'
export const EXPERIMENT_ID = 'qSgK4tS5RgC8J6y21e40dQ'

export const PRICE_COOKIE_NAME = 'ab-price-optimize'
export const PRICE_EXPERIMENT_ID = 'hUHs2nd6SnyLX7bG9xYd2Q'
